{
  "name": "clients-search-web",
  "version": "4.5.3",
  "title": "Buscador de Clientes",
  "languages": [
    "es"
  ],
  "copyright": "Copyright 2015-2026 | Howden Iberia | Todos los derechos reservados",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:en": "ng serve -c=development-en",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "author": "Howden Iberia",
  "license": "ISC"
}